const PAGINATOR_MAX_NUMBER_OF_PAGES_RENDERED = 7;
const PAGINATOR_TRUNCATE_PAGE_BREAKPOINT = 3;
const PAGINATOR_TRUNCATE_CHARACTER = '...';
var PaginatorStartPage;
(function (PaginatorStartPage) {
    PaginatorStartPage["ONE"] = "1";
    PaginatorStartPage["ZERO"] = "0";
})(PaginatorStartPage || (PaginatorStartPage = {}));
var PaginatorControlType;
(function (PaginatorControlType) {
    PaginatorControlType["ARROW"] = "arrow";
    PaginatorControlType["CHEVRON"] = "chevron";
})(PaginatorControlType || (PaginatorControlType = {}));
export { PaginatorControlType, PAGINATOR_MAX_NUMBER_OF_PAGES_RENDERED, PaginatorStartPage, PAGINATOR_TRUNCATE_PAGE_BREAKPOINT, PAGINATOR_TRUNCATE_CHARACTER, };
//# sourceMappingURL=paginator-constants.js.map